import { render, staticRenderFns } from "./vitalSign.vue?vue&type=template&id=6b381781"
import script from "./vitalSign.vue?vue&type=script&lang=js"
export * from "./vitalSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports